var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{staticClass:"pl-6 pt-4 font-weight-light"},[_vm._v(" Top Ten by Total Spend ($) ")]),_c('div',{staticStyle:{"max-width":"480px"}},[_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.pieSeries}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }